if (!String.prototype.replaceAll) {
  // Element table cell renderers call replaceAll in multiple pages.
  // Older browsers/WebViews will throw here and abort the whole table render.
  Object.defineProperty(String.prototype, 'replaceAll', {
    value: function replaceAll(searchValue, replaceValue) {
      if (searchValue instanceof RegExp) {
        if (!searchValue.global) {
          throw new TypeError('String.prototype.replaceAll called with a non-global RegExp argument')
        }
        return this.replace(searchValue, replaceValue)
      }

      return this.split(String(searchValue)).join(String(replaceValue))
    },
    configurable: true,
    writable: true
  })
}
